import { Icon } from '../../icons';

export interface ErrorSpecification {
  buttonClick?: string | (() => void) | null;
  icon?: Icon;
}
